import { Inject, Injectable } from '@angular/core';
import { IAppConfig } from './config/app-config.model';
import { APP_CONFIG } from './config/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class LogService {

  constructor(
    @Inject(APP_CONFIG) protected config: IAppConfig,
  ) { }

  log(str: any){
    // disable log on production
    if(this.config.production) return;

    if(this.config.disableLogService === true) return;
    
    if(!str) return;
    console.log(str);
  }
}
